export default __webpack_public_path__ + "static/media/git.082ea034.svg";